import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, Inject, HostListener, EventEmitter, Output, NgModule } from '@angular/core';
import * as i4 from '@play/common';
import { CommonsComponentModule, CommonsLocationModule, CommonsErrorModule } from '@play/common';
import * as i2 from '@play/translate';
import { TranslationModule } from '@play/translate';
import * as i1 from '@ngrx/store';
import { LoadMediaOnceAction, getMatchMedia, exists, entryAvailable, distinct, LoadPlayerOnceAction, getPlayer, LoadTeamOnceAction, getTeam, LoadMediaAction } from '@play/state';
import { of, combineLatest, BehaviorSubject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@play/api-client';
import { HttpEventType } from '@angular/common/http';
import { MatchModule } from '@play/match';

class MatchMediaFileSkeletonComponent {
}
MatchMediaFileSkeletonComponent.ɵfac = function MatchMediaFileSkeletonComponent_Factory(t) { return new (t || MatchMediaFileSkeletonComponent)(); };
MatchMediaFileSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchMediaFileSkeletonComponent, selectors: [["match-media-file-skeleton"]], decls: 6, vars: 0, consts: [[1, "o-flag", "c-match-media-file", "c-skeleton"], ["viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 1, "o-flag__figure", "u-svg-text", "c-match-media-file__icon"], ["d", "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"], [1, "o-flag__body", "c-match-media-file__name"], [1, "c-skeleton__text"], [1, "c-skeleton__text", 2, "font-size", "0.75em"]], template: function MatchMediaFileSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(1, "svg", 1);
        i0.ɵɵelement(2, "path", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "div", 4);
        i0.ɵɵelement(5, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%] {\n                display: block;\n            }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchMediaFileSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "match-media-file-skeleton",
                templateUrl: "./match-media-file-skeleton.component.html",
                styles: [
                    `
            :host {
                display: block;
            }
        `,
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

class MatchMediaSkeletonComponent {
}
MatchMediaSkeletonComponent.ɵfac = function MatchMediaSkeletonComponent_Factory(t) { return new (t || MatchMediaSkeletonComponent)(); };
MatchMediaSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchMediaSkeletonComponent, selectors: [["match-media-skeleton"]], decls: 12, vars: 7, consts: [[1, "c-card", "c-match-media"], [1, "c-card__title", "c-match-media__title"], [1, "c-card__body", "c-match-media__body"], [1, "u-baseline-tiny"], [1, "c-card__footer", "c-match-media__footer"], ["type", "'flat'", 1, "c-flat-button--primary", 3, "disabled"]], template: function MatchMediaSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h3", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelement(5, "match-media-file-skeleton", 3);
        i0.ɵɵelement(6, "match-media-file-skeleton", 3);
        i0.ɵɵelement(7, "match-media-file-skeleton", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 4);
        i0.ɵɵelementStart(9, "play-button", 5);
        i0.ɵɵtext(10);
        i0.ɵɵpipe(11, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "match-media:match-media-title"), " ");
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", true);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 5, "commons:upload"), " ");
    } }, directives: [MatchMediaFileSkeletonComponent, i4.ButtonComponent], pipes: [i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchMediaSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "match-media-skeleton",
                templateUrl: "./match-media-skeleton.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

class MatchMediaFileComponent {
    ngOnChanges(changes) {
        this.label = this.getLabel();
    }
    getLabel() {
        if (this.team) {
            return `${this.player} - ${this.team}`;
        }
        return this.player;
    }
}
MatchMediaFileComponent.ɵfac = function MatchMediaFileComponent_Factory(t) { return new (t || MatchMediaFileComponent)(); };
MatchMediaFileComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchMediaFileComponent, selectors: [["match-media-file"]], inputs: { name: "name", player: "player", link: "link", type: "type", team: "team" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 3, consts: [[1, "o-flag", "c-match-media-file"], ["viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 1, "o-flag__figure", "u-svg-text", "c-match-media-file__icon"], ["d", "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"], [1, "o-flag__body", "c-match-media-file__name"], [3, "label"], [3, "locationHref"]], template: function MatchMediaFileComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(1, "svg", 1);
        i0.ɵɵelement(2, "path", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "labeled-value", 4);
        i0.ɵɵelementStart(5, "a", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("label", ctx.label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("locationHref", ctx.link);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.name);
    } }, directives: [i4.LabeledValueComponent, i4.LocationDirective], styles: ["[_nghost-%COMP%] {\n                display: block;\n            }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchMediaFileComponent, [{
        type: Component,
        args: [{
                selector: "match-media-file",
                templateUrl: "./match-media-file.component.html",
                styles: [
                    `
            :host {
                display: block;
            }
        `,
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { name: [{
            type: Input
        }], player: [{
            type: Input
        }], link: [{
            type: Input
        }], type: [{
            type: Input
        }], team: [{
            type: Input
        }] }); })();

function MatchMediaComponent_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MatchMediaComponent_ng_container_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MatchMediaComponent_ng_container_0_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MatchMediaComponent_ng_container_0_ng_template_12_match_media_file_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "match-media-file", 12);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
} if (rf & 2) {
    const media_r13 = ctx.$implicit;
    i0.ɵɵproperty("name", media_r13.file.title)("type", media_r13.file.type)("link", media_r13.file.filename)("player", i0.ɵɵpipeBind1(1, 5, media_r13.player$))("team", i0.ɵɵpipeBind1(2, 7, media_r13.team$));
} }
function MatchMediaComponent_ng_container_0_ng_template_12_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "match-media:no-media-yet"), " ");
} }
function MatchMediaComponent_ng_container_0_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MatchMediaComponent_ng_container_0_ng_template_12_match_media_file_0_Template, 3, 9, "match-media-file", 10);
    i0.ɵɵtemplate(1, MatchMediaComponent_ng_container_0_ng_template_12_div_1_Template, 3, 3, "div", 11);
} if (rf & 2) {
    const mediaEntries_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", mediaEntries_r1)("ngForTrackBy", ctx_r6.trackMediaEntries);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(mediaEntries_r1 == null ? null : mediaEntries_r1.length));
} }
function MatchMediaComponent_ng_container_0_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "match-media-file-skeleton", 14);
    i0.ɵɵelement(1, "match-media-file-skeleton", 14);
    i0.ɵɵelement(2, "match-media-file-skeleton", 14);
} }
function MatchMediaComponent_ng_container_0_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"));
} }
function MatchMediaComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵelementStart(2, "h2", 2);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 3);
    i0.ɵɵtemplate(6, MatchMediaComponent_ng_container_0_ng_container_6_Template, 1, 0, "ng-container", 4);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtemplate(8, MatchMediaComponent_ng_container_0_ng_container_8_Template, 1, 0, "ng-container", 4);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵtemplate(10, MatchMediaComponent_ng_container_0_ng_container_10_Template, 1, 0, "ng-container", 4);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵtemplate(12, MatchMediaComponent_ng_container_0_ng_template_12_Template, 2, 3, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(14, MatchMediaComponent_ng_container_0_ng_template_14_Template, 3, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(16, MatchMediaComponent_ng_container_0_ng_template_16_Template, 3, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 8);
    i0.ɵɵelementStart(19, "play-button", 9);
    i0.ɵɵlistener("clicked", function MatchMediaComponent_ng_container_0_Template_play_button_clicked_19_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.openUploadDialog(); });
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(13);
    const _r7 = i0.ɵɵreference(15);
    const _r9 = i0.ɵɵreference(17);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, "match-media:match-media-title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 11, ctx_r0.isReady$))("ngIfThen", _r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(9, 13, ctx_r0.isLoading$))("ngIfThen", _r7);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 15, ctx_r0.hasError$))("ngIfThen", _r9);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("type", "flat");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 17, "commons:upload"), " ");
} }
class MatchMediaComponent {
    constructor(store, ds) {
        this.store = store;
        this.ds = ds;
        this.dialogOpen = false;
    }
    ngOnInit() {
        this.store.dispatch(new LoadMediaOnceAction(this.matchId));
        this.media$ = this.store.select(getMatchMedia(this.matchId)).pipe(filter(exists));
        this.mediaEntries$ = this.media$.pipe(filter(entryAvailable), distinct(media => media.entry), map(files => files.map(file => ({
            file: file,
            player$: this.getPlayer(file.player).pipe(map(player => (player ? player.nickname : ""))),
            team$: this.isTeam(file.player, file.contestant)
                ? this.getTeam(file.contestant).pipe(map(team => (team ? team.name : "")))
                : of(null),
        }))));
        this.isLoading$ = this.getIsLoading();
        this.hasError$ = this.getHasError();
        this.isReady$ = this.getIsReady();
    }
    isTeam(playerId, contestantId) {
        return playerId !== contestantId;
    }
    getIsReady() {
        return combineLatest(this.isLoading$, this.hasError$).pipe(map(([loading, error]) => Boolean(!loading && !error)));
    }
    getIsLoading() {
        return this.media$.pipe(map(entry => Boolean(!entry || (entry.loading && !entry.entry))));
    }
    getHasError() {
        return this.media$.pipe(map(entry => Boolean(entry && entry.error)));
    }
    getPlayer(id) {
        this.store.dispatch(new LoadPlayerOnceAction(id));
        return this.store.select(getPlayer(id)).pipe(filter(entryAvailable), map(entry => entry.entry));
    }
    getTeam(id) {
        this.store.dispatch(new LoadTeamOnceAction(id));
        return this.store.select(getTeam(id)).pipe(filter(entryAvailable), map(entry => entry.entry));
    }
    onDragOver(event) {
        event.preventDefault();
        this.openUploadDialog();
    }
    openUploadDialog() {
        if (this.dialogOpen) {
            return;
        }
        this.dialogOpen = true;
        this.ds
            .openMatchMediaUploadDialog({ matchId: this.matchId })
            .then(x => this.store.dispatch(new LoadMediaAction(this.matchId, true)))
            .catch(x => x)
            .then(x => (this.dialogOpen = false));
    }
    trackMediaEntries(index, item) {
        return index;
    }
}
MatchMediaComponent.ɵfac = function MatchMediaComponent_Factory(t) { return new (t || MatchMediaComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject("DialogService")); };
MatchMediaComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchMediaComponent, selectors: [["match-media"]], hostBindings: function MatchMediaComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("dragover", function MatchMediaComponent_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragenter", function MatchMediaComponent_dragenter_HostBindingHandler($event) { return ctx.onDragOver($event); });
    } }, inputs: { matchId: "matchId" }, decls: 2, vars: 3, consts: [[4, "ngIf"], [1, "c-card", "c-match-media"], [1, "c-card__title", "c-match-media__title"], [1, "c-card__body", "c-match-media__body"], [4, "ngIf", "ngIfThen"], ["ready", ""], ["loading", ""], ["error", ""], [1, "c-card__footer", "c-match-media__footer"], [1, "c-flat-button--primary", 3, "type", "clicked"], ["class", "u-baseline-tiny", 3, "name", "type", "link", "player", "team", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "c-match-media__body__empty", 4, "ngIf"], [1, "u-baseline-tiny", 3, "name", "type", "link", "player", "team"], [1, "c-match-media__body__empty"], [1, "u-baseline-tiny"]], template: function MatchMediaComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MatchMediaComponent_ng_container_0_Template, 22, 19, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.mediaEntries$));
    } }, directives: [i2$1.NgIf, i4.ButtonComponent, i2$1.NgForOf, MatchMediaFileComponent, MatchMediaFileSkeletonComponent, i4.InlineErrorComponent], pipes: [i2$1.AsyncPipe, i2.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchMediaComponent, [{
        type: Component,
        args: [{
                selector: "match-media",
                templateUrl: "./match-media.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.Store }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, { matchId: [{
            type: Input
        }], onDragOver: [{
            type: HostListener,
            args: ["dragover", ["$event"]]
        }, {
            type: HostListener,
            args: ["dragenter", ["$event"]]
        }] }); })();

const matchMediaTexts = {
    "match-media:match-media-title": "Match media",
    "match-media:no-media-yet": "No media uploaded yet.",
    "commons:upload": "upload",
};

const matchMediaFileTexts = {};

function MatchMediaUploadComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "file-upload-file", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const file_r4 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", file_r4.name)("percent", file_r4.percent)("error", file_r4.error);
} }
function MatchMediaUploadComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MatchMediaUploadComponent_ng_container_3_ng_container_1_Template, 2, 3, "ng-container", 9);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const file$_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, file$_r2));
} }
function MatchMediaUploadComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "match-media-upload:no-file-in-progress"), " ");
} }
class MatchMediaUploadComponent {
    constructor(matchResource, translate) {
        this.matchResource = matchResource;
        this.translate = translate;
        this.done = new EventEmitter();
        this.uploads = [];
    }
    uploadFiles(files) {
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploads.push(this.uploadFile(file));
        }
    }
    uploadDone(obs) {
        const currentData = obs.getValue();
        obs.next(Object.assign(Object.assign({}, currentData), { percent: 100 }));
    }
    uploadProgressUpdate(obs, event) {
        const currentData = obs.getValue();
        if (event.type === HttpEventType.UploadProgress) {
            const uploadEvent = event;
            const progress = Math.min(90, (uploadEvent.loaded / uploadEvent.total) * 100);
            obs.next(Object.assign(Object.assign({}, currentData), { percent: progress }));
        }
        if (event.type === HttpEventType.Response) {
            this.uploadDone(obs);
        }
    }
    uploadFailed(obs) {
        const currentData = obs.getValue();
        obs.next(Object.assign(Object.assign({}, currentData), { error: this.translate.translate("match-media-upload:upload-error", {}) }));
    }
    uploadFile(file) {
        const obs = new BehaviorSubject({
            percent: 0,
            name: file.name,
            error: null,
        });
        const emit = (event) => this.uploadProgressUpdate(obs, event);
        const done = () => this.uploadDone(obs);
        const error = () => this.uploadFailed(obs);
        this.matchResource
            .uploadMatchmediaOfMatch(this.matchId, file)
            .pipe(takeUntil(obs.pipe(filter(x => x.percent === 100))))
            .subscribe(emit, error, done);
        return obs.asObservable();
    }
}
MatchMediaUploadComponent.ɵfac = function MatchMediaUploadComponent_Factory(t) { return new (t || MatchMediaUploadComponent)(i0.ɵɵdirectiveInject(i1$1.MatchResource), i0.ɵɵdirectiveInject(i2.TranslateService)); };
MatchMediaUploadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MatchMediaUploadComponent, selectors: [["match-media-upload"]], inputs: { matchId: "matchId" }, outputs: { done: "done" }, decls: 11, vars: 6, consts: [[1, "c-card", "c-match-media-upload"], [1, "c-card__body", "o-grid"], [1, "o-grid__item", "u-1/2", "c-match-media-upload__files"], [4, "ngFor", "ngForOf"], ["class", "c-match-media-upload__files__empty", 4, "ngIf"], [1, "o-grid__item", "u-1/2", "c-match-media-upload__dropzone"], [3, "dropped"], [1, "c-card__footer"], [1, "c-flat-button--primary", 3, "type", "clicked"], [4, "ngIf"], [1, "u-baseline-small", 3, "name", "percent", "error"], [1, "c-match-media-upload__files__empty"]], template: function MatchMediaUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, MatchMediaUploadComponent_ng_container_3_Template, 3, 3, "ng-container", 3);
        i0.ɵɵtemplate(4, MatchMediaUploadComponent_div_4_Template, 3, 3, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelementStart(6, "file-upload-dropzone", 6);
        i0.ɵɵlistener("dropped", function MatchMediaUploadComponent_Template_file_upload_dropzone_dropped_6_listener($event) { return ctx.uploadFiles($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelementStart(8, "play-button", 8);
        i0.ɵɵlistener("clicked", function MatchMediaUploadComponent_Template_play_button_clicked_8_listener() { return ctx.done.emit(true); });
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.uploads);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.uploads.length);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("type", "flat");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 4, "commons:done"), " ");
    } }, directives: [i2$1.NgForOf, i2$1.NgIf, i4.FileUploadDropzoneComponent, i4.ButtonComponent, i4.FileUploadFileComponent], pipes: [i2.TranslatePipe, i2$1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchMediaUploadComponent, [{
        type: Component,
        args: [{
                selector: "match-media-upload",
                templateUrl: "./match-media-upload.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.MatchResource }, { type: i2.TranslateService }]; }, { matchId: [{
            type: Input
        }], done: [{
            type: Output
        }] }); })();

const matchMediaUploadTexts = {
    "match-media-upload:no-file-in-progress": "No file upload in progress yet.",
    "match-media-upload:upload-error": "Fileupload failed.",
    "file-upload-dropzone:drop-file-or-choose": "Drop files to upload here or",
    "commons:choose": "choose",
    "commons:done": "done",
};

class MatchMediaModule {
}
MatchMediaModule.ɵfac = function MatchMediaModule_Factory(t) { return new (t || MatchMediaModule)(); };
MatchMediaModule.ɵmod = i0.ɵɵdefineNgModule({ type: MatchMediaModule });
MatchMediaModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, CommonsComponentModule, TranslationModule, CommonsLocationModule, CommonsErrorModule, MatchModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MatchMediaModule, { declarations: [MatchMediaComponent,
        MatchMediaFileComponent,
        MatchMediaUploadComponent,
        MatchMediaFileSkeletonComponent,
        MatchMediaSkeletonComponent], imports: [CommonModule, CommonsComponentModule, TranslationModule, CommonsLocationModule, CommonsErrorModule, MatchModule], exports: [MatchMediaComponent,
        MatchMediaFileComponent,
        MatchMediaUploadComponent,
        MatchMediaFileSkeletonComponent,
        MatchMediaSkeletonComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MatchMediaModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, CommonsComponentModule, TranslationModule, CommonsLocationModule, CommonsErrorModule, MatchModule],
                declarations: [
                    MatchMediaComponent,
                    MatchMediaFileComponent,
                    MatchMediaUploadComponent,
                    MatchMediaFileSkeletonComponent,
                    MatchMediaSkeletonComponent,
                ],
                exports: [
                    MatchMediaComponent,
                    MatchMediaFileComponent,
                    MatchMediaUploadComponent,
                    MatchMediaFileSkeletonComponent,
                    MatchMediaSkeletonComponent,
                ],
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MatchMediaComponent, MatchMediaFileComponent, MatchMediaFileSkeletonComponent, MatchMediaModule, MatchMediaSkeletonComponent, MatchMediaUploadComponent, matchMediaFileTexts, matchMediaTexts, matchMediaUploadTexts };
//# sourceMappingURL=play-match-media.js.map
